import { useState, FormEvent } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('phone', formData.phone);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d5h5fnjihlvellpk4vlg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5511934728670?text=Olá!%20Vim%20pelo%20site%20e%20gostaria%20de%20tirar%20algumas%20dúvidas.%20Pode%20me%20orientar?', '_blank');
  };

  return (
    <section id="contato" className="py-16 md:py-32 px-6 md:px-20 bg-gray-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-20">
          <div>
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4 md:mb-6">Entre em Contato</h2>
            <p className="text-gray-600 text-base md:text-lg mb-8 md:mb-12 leading-relaxed">
              Estamos prontos para atender você. Agende sua visita ou tire suas dúvidas conosco.
            </p>

            <div className="space-y-6 md:space-y-8">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-white text-lg md:text-xl"></i>
                </div>
                <div>
                  <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-1 md:mb-2">Endereço</h3>
                  <p className="text-sm md:text-base text-gray-600">Rua Delfino Facchina, 1145<br />São Paulo, Brazil</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-white text-lg md:text-xl"></i>
                </div>
                <div>
                  <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-1 md:mb-2">Telefone</h3>
                  <p className="text-sm md:text-base text-gray-600">(11) 93472-8670<br />(11) 3456-7890</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-white text-lg md:text-xl"></i>
                </div>
                <div>
                  <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-1 md:mb-2">Horário</h3>
                  <p className="text-sm md:text-base text-gray-600">Segunda a Sexta: 9h às 19h<br />Sábado: 9h às 14h</p>
                </div>
              </div>

              <button
                onClick={handleWhatsAppClick}
                className="mt-6 bg-teal-500 hover:bg-teal-600 text-white px-8 py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                Fale Conosco no WhatsApp
              </button>
            </div>
          </div>

          <div>
            <form onSubmit={handleSubmit} className="bg-white p-6 md:p-10 rounded-2xl shadow-lg" data-readdy-form id="contact-form">
              <div className="mb-5 md:mb-6">
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                  Nome Completo
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                  placeholder="Seu nome"
                />
              </div>

              <div className="mb-5 md:mb-6">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  E-mail
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                  placeholder="seu@email.com"
                />
              </div>

              <div className="mb-5 md:mb-6">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                  Telefone
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                  placeholder="(11) 98765-4321"
                />
              </div>

              <div className="mb-5 md:mb-6">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                  Mensagem
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm resize-none"
                  placeholder="Como podemos ajudar?"
                />
                <p className="text-xs text-gray-500 mt-1">{formData.message.length}/500 caracteres</p>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-teal-500 hover:bg-teal-600 text-white py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? 'Enviando...' : 'Enviar Mensagem'}
              </button>

              {submitStatus === 'success' && (
                <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg">
                  <p className="text-green-800 text-sm">Mensagem enviada com sucesso! Entraremos em contato em breve.</p>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg">
                  <p className="text-red-800 text-sm">Erro ao enviar mensagem. Tente novamente.</p>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}